<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
    
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="4"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
              style="cursor: pointer;"
              @click.native="clickCard(card)"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    methods: {
      clickCard(card) {
        if (card.url) {
          window.location.href = card.url;
        } else if (card.link) {
          this.$router.push(card.link);
        }
      },
    },

    data: () => ({
      cards: [
        {
          icon: 'mdi-book',
          title: 'Annotations',
          text: 'Chapter by chapter commentary and behind-the-scenes details.',
          link: '/marianne-annotations',
        },
        {
          icon: 'mdi-pinterest',
          title: 'Pinterest Boards',
          text: 'Goth dream house, location inspiration, memes, and more.',
          url: 'https://www.pinterest.com/ehammer_author/boards/'
        },
        {
          icon: 'mdi-checkbox-marked',
          title: 'Content Guide',
          text: 'Unleash your parental powers.',
          link: '/marianne-content-guide',
        },
        // {
        //   icon: 'mdi-puzzle-outline',
        //   title: '24/7 Support',
        //   text: 'Efficiently unleash media information without cross-media value. Quickly maximize value timely deliverables schemas.',
        // },
      ],
    }),
  }
</script>
